import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import Shape from '../components/shape'

import bg1 from '../assets/images/bg-profile.jpg'
import client5 from '../assets/images/client/05.jpg'
import image1 from '../assets/images/freelancer/1.jpg'
import image2 from '../assets/images/freelancer/2.jpg'

import { profileConnection } from '../data/data'

import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';

export default function PageProfile() {
  let images = [image1, image2]
  let [activeIndex, setActiveIndex] = useState(0)
  let [show, setShow] = useState(false)

  const handleClick = (index) =>{
    setShow(true);
    setActiveIndex(index)
  }

  return (
    <>
     <Navbar bg={true}/> 

    <section className="bg-profile bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="profile-overlay"></div>
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-lg-12">
                  <div className="profile">
                      <div className="row align-items-center">
                          <div className="col-lg-2 col-md-3 text-md-start text-center">
                              <img src={client5} className="img-fluid shadow mx-auto d-block rounded-pill" alt=""/>
                          </div>
                          <div className="col-lg-10 col-md-9">
                              <div className="row align-items-center">
                                  <div className="col-md-8 text-md-start text-center mt-4 mt-sm-0">
                                      <h3 className="title mb-0">Amanda Hyer</h3>
                                      <small className="text-muted h6 me-2">Web Designer</small>
                                      <small className="text-warning h6"><Link to="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39206.002432144705!2d-95.4973981212445!3d29.709510002925988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c16de81f3ca5%3A0xf43e0b60ae539ac9!2sGerald+D.+Hines+Waterwall+Park!5e0!3m2!1sen!2sin!4v1566305861440!5m2!1sen!2sin" className="video-play-icon h6 text-warning googlemap"><i className="mdi mdi-map-marker"></i> Sydney, Australia</Link></small>
                                      <ul className="list-inline mb-0 mt-2">
                                          <li className="list-inline-item me-2"><Link to="#" className="text-muted" title="Linkedin"><i className="mdi mdi-linkedin me-2"></i>amanda_hyer</Link></li>
                                          <li className="list-inline-item"><Link to="#" className="text-muted" title="Skype"><i className="mdi mdi-skype me-2"></i>@amanda_hyer</Link></li>
                                      </ul>
                                  </div>
                                  <div className="col-md-4 text-md-end text-center mt-4 mt-sm-0">
                                      <Link to="#" className="btn btn-outline-primary">Add Now <i className="mdi mdi-plus"></i></Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div> 
    </section>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-lg-4 col-md-6">
                  <div className="sidebar">
                      <div className="widget p-4 rounded bg-white border">
                          <h4 className="widget-title mb-3">Aboutus</h4>
                          <p className="text-muted">Obviously I'M Web Designer. Web Developer with over 3 years of experience.</p>
                          <ul className="list-unstyled">
                              <li className="mb-1"><span><i className="mdi mdi-trophy text-muted"></i> Worked at </span> <Link to="#" className="text-warning">Envato Pvt Ltd, Australia</Link></li>
                              <li className="mb-1"><span><i className="mdi mdi-school text-muted"></i> Studied at </span> <Link to="#" className="text-warning">Envato Uni, Australia</Link></li>
                              <li className="mb-1"><span><i className="mdi mdi-school text-muted"></i> Went to </span> <Link to="#" className="text-warning">Envato School, Australia</Link></li>
                              <li className="mb-1"><span><i className="mdi mdi-map-marker text-muted"></i> From </span> <Link to="#" className="text-warning">Australia</Link></li>
                          </ul>

                          <Link to="#" className="text-dark h6">See More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                      </div>

                      <div className="mt-4 pt-2">
                          <div className="widget p-4 rounded bg-white border">
                              <h6 className="float-end"><Link to="#" className="text-muted">160+</Link></h6>
                              <h4 className="widget-title mb-3">Connections</h4>
                              
                              <div className="widget-grid overflow-hidden mb-3">
                                {profileConnection.map((item,index)=>{
                                  return(
                                    <div className="item" key={index}><Link to="#"><img src={item} className="img-fluid shadow mx-auto d-block avatar-medium rounded-pill" alt=""/></Link></div>
                                  )
                                })}
                              </div>

                              <Link to="#" className="text-dark h6">See All Connections <i className="mdi mdi-chevron-right align-middle"></i></Link>
                          </div>
                      </div>
                  </div>
              </div>

              <div className="col-lg-8 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="rounded border position-relative overflow-hidden">
                      <div className="p-2 bg-light border-bottom">
                          <h6 className="mb-0">Create Post</h6>
                      </div>
                      <form>
                          <div className="row">
                              <div className="col-md-12">
                                  <div className="d-flex mb-0 position-relative">
                                      <img src={client5} className="img-fluid avatar mt-1 ms-1 shadow border avatar-ex-sm rounded-pill" alt=""/>
                                      <textarea name="text" id="comments" rows="4" className="form-control shadow-none h6 border-0" required placeholder="Write something here :"></textarea>
                                  </div>
                              </div>
                              <div className="col-md-12">
                                  <div className="d-grid">
                                      <input type="submit" id="submit" name="send" className="btn btn-primary" value="Post"/>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>

                  <div className="row">
                      <div className="col-12 mt-4 pt-2">
                          <div className="profile-post rounded border position-relative overflow-hidden">
                              <div className="author d-flex bg-light p-3">
                                  <img src={client5} className="img-fluid avatar avatar-small rounded-pill me-3 shadow" alt=""/>
                                  <div className="author mt-2 pt-1">
                                      <h6 className="mb-0"><Link to="#" className="text-dark">Amanda Hyer</Link></h6>
                                      <small className="text-muted">1 Days ago</small>
                                  </div>
                              </div>
                              <div className="p-3">
                                  <p className="text-muted mb-0">Dummy text is also used to demonstrate the appearance of different typefaces and layouts</p>
                              </div>
                              <div className="images">
                                  <Link to="#" onClick={()=>handleClick(0)} className="lightbox d-inline-block" title="">
                                      <img src={image1} className="img-fluid" alt=""/>
                                  </Link>
                              </div>

                              <div className="p-3">
                                  <span className="float-end"><Link to="#" className="text-muted comments"><i className="mdi mdi-comment-outline"></i> 20 Comments</Link></span>
                                  <span><Link to="#" className="text-muted like"><i className="mdi mdi-heart"></i> 40 Hits</Link></span>
                              </div>
                          </div>
                      </div>

                      <div className="col-12 mt-4 pt-2">
                          <div className="profile-post rounded border position-relative overflow-hidden">
                              <div className="author d-flex bg-light p-3">
                                  <img src={client5} className="img-fluid avatar avatar-small rounded-pill me-3 shadow" alt=""/>
                                  <div className="author mt-2 pt-1">
                                      <h6 className="mb-0"><Link to="#" className="text-dark">Amanda Hyer</Link></h6>
                                      <small className="text-muted">3 Days ago</small>
                                  </div>
                              </div>
                              <div className="p-3 text-center">
                                  <p className="text-muted h6 fst-italic mb-0">" The most well-known dummy text is the If the distribution of letters and 'words' is random, the reader will not be distracted from making a neutral judgement which is said to have originated in the 16th century. Lorem Ipsum is composed in a pseudo-Latin language "</p>
                              </div>

                              <div className="p-3 bg-light">
                                  <span className="float-end"><Link to="#" className="text-muted comments"><i className="mdi mdi-comment-outline"></i> 3 Comments</Link></span>
                                  <span><Link to="#" className="text-muted like"><i className="mdi mdi-heart"></i> 25 Hits</Link></span>
                              </div>
                          </div>
                      </div>

                      <div className="col-12 mt-4 pt-2">
                          <div className="profile-post rounded border position-relative overflow-hidden">
                              <div className="author d-flex bg-light p-3">
                                  <img src={client5} className="img-fluid avatar avatar-small rounded-pill me-3 shadow" alt=""/>
                                  <div className="author mt-2 pt-1">
                                      <h6 className="mb-0"><Link to="#" className="text-dark">Amanda Hyer</Link></h6>
                                      <small className="text-muted">4 Days ago</small>
                                  </div>
                              </div>
                              <div className="p-3">
                                  <p className="text-muted mb-0">If the distribution of letters and 'words' is random, the reader will not be distracted from making a neutral judgement</p>
                              </div>
                              <div className="images">
                                  <Link to="#" onClick={()=>handleClick(1)} className="lightbox d-inline-block" title="">
                                      <img src={image2} className="img-fluid" alt=""/>
                                  </Link>
                              </div>

                              <div className="p-3">
                                  <span className="float-end"><Link to="#" className="text-muted comments"><i className="mdi mdi-comment-outline"></i> 14 Comments</Link></span>
                                  <span><Link to="#" className="text-muted like"><i className="mdi mdi-heart"></i> 68 Hits</Link></span>
                              </div>
                          </div>
                      </div>

                      <div className="col-12 mt-4 pt-2 text-center">
                          <Link to="#" className="text-primary px-2 py-1 rounded shadow"><i className="mdi mdi-sync mdi-spin"></i> Load More</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

        {show && (
          <Lightbox
            mainSrc={images[activeIndex]}
            nextSrc={images[(activeIndex + 1) % images.length]}
            prevSrc={images[(activeIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setShow(false)}
            onMovePrevRequest={() => setActiveIndex((activeIndex + images.length - 1) % images.length)
            }
            onMoveNextRequest={() =>setActiveIndex((activeIndex + 1) % images.length)
            }
            />
          )}
    <Shape/>
    <Footer/>
    </>
  )
}
